var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "applicants-wrapper",
      attrs: { id: "credit-applicants-container" },
    },
    [
      !_vm.loading
        ? _c("incident-message", {
            staticClass: "p-2",
            attrs: { "service-name": "equifax" },
            on: { update: _vm.handleIncidentUpdate },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card-header py-4" }, [
        _c(
          "div",
          { staticClass: "row align-items-end align-items-center" },
          _vm._l(_vm.columnHeaders, function (columnHeader, index) {
            return _c(
              "div",
              { key: "column-header-" + index, class: columnHeader.size },
              [
                _c(
                  "h6",
                  {
                    class: [
                      "text-center m-0 cursor-auto text-light-gray",
                      columnHeader.label ===
                      _vm.$t("direct-to-lender.creditBureau.amlAssist")
                        ? "text-normal"
                        : "theader-big",
                    ],
                    attrs: { title: columnHeader.label },
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(columnHeader.label) + "\n        "
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("loader")
        : _c(
            "div",
            { staticClass: "card-body applicants-table-wrapper" },
            _vm._l(_vm.creditSubjects, function (creditSubject, index) {
              return _c(
                "div",
                {
                  key: "creditSubject-" + creditSubject.firstName,
                  staticClass: "row",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-2 d-flex flex-column align-items-center justify-content-center",
                    },
                    [
                      _c("p", { staticClass: "grey-text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.fullSubjectName(index)) +
                            "\n        "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-2 d-flex flex-column align-items-center justify-content-center",
                    },
                    [
                      _c("p", { staticClass: "grey-text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(creditSubject.dateOfBirth) +
                            "\n        "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "field",
                    {
                      staticClass:
                        "col d-flex flex-column align-items-center justify-content-center",
                    },
                    [
                      _c("date-section", {
                        attrs: {
                          disabled: creditSubject.AML || creditSubject.PEP,
                          name: "authorization-obtained",
                          placeholder: "YYYY-MM-DD",
                          "class-name": "date-format",
                        },
                        model: {
                          value: creditSubject.authorizationDate,
                          callback: function ($$v) {
                            _vm.$set(creditSubject, "authorizationDate", $$v)
                          },
                          expression: "creditSubject.authorizationDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "field",
                    {
                      attrs: {
                        "size-class":
                          "col d-flex flex-column align-items-center justify-content-center",
                      },
                    },
                    [
                      _c("text-section", {
                        attrs: {
                          disabled: creditSubject.AML || creditSubject.PEP,
                          name: "authorization-method",
                          placeholder: _vm.$t(
                            "direct-to-lender.creditBureau.method"
                          ),
                          label: _vm.$t("direct-to-lender.creditBureau.method"),
                        },
                        model: {
                          value: creditSubject.authorizationMethod,
                          callback: function ($$v) {
                            _vm.$set(creditSubject, "authorizationMethod", $$v)
                          },
                          expression: "creditSubject.authorizationMethod",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "field",
                    {
                      attrs: {
                        "size-class":
                          "col d-flex flex-column align-items-center justify-content-center",
                      },
                    },
                    [
                      _c("checkbox-section", {
                        attrs: {
                          name: "single",
                          "multi-line": false,
                          label: _vm.$t("direct-to-lender.creditBureau.bureau"),
                          "hidden-label": "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.handleBureauChange(index)
                          },
                        },
                        model: {
                          value: creditSubject.bureau,
                          callback: function ($$v) {
                            _vm.$set(creditSubject, "bureau", $$v)
                          },
                          expression: "creditSubject.bureau",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "field",
                    {
                      attrs: {
                        "size-class":
                          "col d-flex flex-column align-items-center justify-content-center",
                      },
                    },
                    [
                      _c("notification-popover", {
                        attrs: {
                          placement: "topleft",
                          triggers: "hover",
                          disabled: !creditSubject.copyLiabilities,
                          show: creditSubject.copyLiabilities,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "popoverTarget",
                              fn: function () {
                                return [
                                  _c("checkbox-section", {
                                    attrs: {
                                      name: "copy-liabilities",
                                      "multi-line": false,
                                      disabled: !creditSubject.bureau,
                                      label: _vm.$t(
                                        "direct-to-lender.creditBureau.copyLiabilities"
                                      ),
                                      "hidden-label": "",
                                    },
                                    model: {
                                      value: creditSubject.copyLiabilities,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          creditSubject,
                                          "copyLiabilities",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "creditSubject.copyLiabilities",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "popoverContent",
                              fn: function () {
                                return [
                                  _c("p", { staticClass: "m-0" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "direct-to-lender.creditBureau.liabilitiesCopiedWillNotBeSubmitted"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "field",
                    {
                      attrs: {
                        "size-class":
                          "col d-flex flex-column align-items-center justify-content-center",
                      },
                    },
                    [
                      _c("checkbox-section", {
                        attrs: {
                          name: "single",
                          "multi-line": false,
                          label: _vm.$t(
                            "direct-to-lender.creditBureau.amlAssist"
                          ),
                          "hidden-label": "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.handleAMLChange(index)
                          },
                        },
                        model: {
                          value: creditSubject.AML,
                          callback: function ($$v) {
                            _vm.$set(creditSubject, "AML", $$v)
                          },
                          expression: "creditSubject.AML",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "field",
                    {
                      attrs: {
                        "size-class":
                          "col d-flex flex-column align-items-center justify-content-center",
                      },
                    },
                    [
                      _c("checkbox-section", {
                        attrs: {
                          name: "single",
                          "multi-line": false,
                          label: _vm.$t(
                            "direct-to-lender.creditBureau.pepOrSanctions"
                          ),
                          "hidden-label": "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.handlePEPOrSanctions(index)
                          },
                        },
                        model: {
                          value: creditSubject.PEP,
                          callback: function ($$v) {
                            _vm.$set(creditSubject, "PEP", $$v)
                          },
                          expression: "creditSubject.PEP",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "card-footer px-5 bg-light d-flex flex-row align-items-center justify-content-end",
        },
        [
          _c(
            "div",
            { staticClass: "w-auto mr-2 d-flex flex-row" },
            [
              _c(
                "button",
                {
                  staticClass:
                    "btn bold btn-white btn-sm print-consent-form mr-2",
                  on: { click: _vm.handlePrintConsent },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("direct-to-lender.creditBureau.printConsentForm")
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "simple-button",
                {
                  attrs: {
                    type: ["bold", "btn-primary", "btn-sm"],
                    loading: _vm.requestingCreditBureau,
                    disabled: _vm.disablePull,
                  },
                  on: { click: _vm.handleRequest },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("direct-to-lender.creditBureau.request")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.loading && _vm.errors.length
            ? [
                _c("notification-popover", {
                  attrs: {
                    triggers: "hover",
                    disabled: _vm.missingFilogixDetailsOrAccess,
                    "keep-open": _vm.missingFilogixDetailsOrAccess,
                    show: !!_vm.errors.length,
                    boundary: "#credit-applicants-container",
                    container: "#credit-applicants-container",
                    placement: "topleft",
                    type: _vm.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY
                      ? "error"
                      : "info",
                  },
                  scopedSlots: _vm._u(
                    [
                      !_vm.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY
                        ? {
                            key: "popoverTarget",
                            fn: function () {
                              return [
                                _c("icon", {
                                  staticClass: "clickable text-grey",
                                  attrs: {
                                    id: "request-bureau-errors",
                                    name:
                                      "" +
                                      (_vm.missingFilogixDetailsOrAccess
                                        ? "exclamation-circle"
                                        : "info-circle"),
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                      {
                        key: "popoverContent",
                        fn: function () {
                          return _vm._l(_vm.errors, function (error, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                class: {
                                  "mb-2":
                                    error.applicantName &&
                                    index === _vm.errors.length - 2,
                                },
                              },
                              [
                                !error.applicantName
                                  ? _c("span", [_vm._v(_vm._s(error.errMsg))])
                                  : error.errMsg
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row align-items-center mb-1",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "mb-0" },
                                            [
                                              _c("icon", {
                                                staticClass: "bold",
                                                attrs: { name: "times-circle" },
                                              }),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "direct-to-lender.creditBureau.creditPullFor"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "bold" },
                                                [
                                                  _vm._v(
                                                    _vm._s(error.applicantName)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "global.words.failed"
                                                    )
                                                  ) +
                                                  ":\n                "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        {
                                          staticClass: "pl-3 bullet",
                                          class: {
                                            "mb-0": error.errMsg.length === 1,
                                          },
                                        },
                                        _vm._l(error.errMsg, function (errMsg) {
                                          return _c("li", { key: errMsg }, [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm._f("finishWithDot")(
                                                    errMsg
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ])
                                        }),
                                        0
                                      ),
                                    ])
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex flex-row align-items-center",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "mb-1" },
                                          [
                                            _c("icon", {
                                              staticClass: "bold",
                                              attrs: { name: "check-circle" },
                                            }),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "direct-to-lender.creditBureau.creditPullFor"
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "bold" },
                                              [
                                                _vm._v(
                                                  _vm._s(error.applicantName)
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "global.words.succeeded"
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                              ]
                            )
                          })
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.requestingCreditBureau
            ? _c("div", { staticClass: "overlay clear" })
            : _vm._e(),
          _vm._v(" "),
          _c("filogix-details-modal", {
            ref: "filogixDetailsModal",
            on: { submit: _vm.handleFilogixDetailsSubmit },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }